import dayjs from "dayjs";

export const QUOTE_CATEGORIES = ["photography", "equipment", "travel", "other"];

export const QUOTE_CURRENCIES = ["GBP", "CNY", "EUR", "USD"];

export const DEFAULT_PORTFOLIO_URL = "https://heicreative.co.uk";

export const DEFAULT_CURRENCY = "GBP";

export const DEFAULT_GLOBAL_NOTES = [
    "超时费每小时100镑，超时15分钟内免费，超过15分钟按一小时计费",
];

let nextLineId = 0;

export function createLineId() {
    nextLineId += 1;
    return `line-${nextLineId}`;
}

export function createEmptyLine() {
    return {
        id: createLineId(),
        name: "",
        unitPrice: "",
        quantity: 1,
        note: "",
    };
}

export function createDefaultCategories() {
    return QUOTE_CATEGORIES.reduce((acc, key) => {
        acc[key] = [createEmptyLine()];
        return acc;
    }, {});
}

export function createDefaultFormState() {
    return {
        projectName: "",
        quoteDate: dayjs(),
        validUntil: null,
        currency: DEFAULT_CURRENCY,
        portfolioUrl: DEFAULT_PORTFOLIO_URL,
        hideSubitemPrices: false,
        globalNotes: [...DEFAULT_GLOBAL_NOTES],
        categories: createDefaultCategories(),
    };
}
